<!-- 企业简介 -->
<template>
  <div>
    <!-- <div class="video">
      <img src="https://jw-ppt.oss-cn-beijing.aliyuncs.com/zl/project/FutureGens/img/guanyu/banner_1.png" alt="" />
    </div> -->
    <div class="content_top">
      <div class="content_top-box">
        <h3>{{ text17 }}</h3>
        <div>
          <p>{{ text18 }}</p>
          <br />
          <div v-if="text19">
            <p>{{ text19 }}</p>
            <br />
          </div>
          <p>{{ text20 }}</p>
          <br />
          <p>{{ text21 }}</p>
          <br />
          <p>{{ text22 }}</p>
          <br />
          <p>{{ text28 }}</p>
        </div>
      </div>
    </div>
    <div class="content_bottom">
      <div class="content_bottom_left">
        <div class="left_top">
          <img src="https://jw-ppt.oss-cn-beijing.aliyuncs.com/zl/project/FutureGens/img/guanyu/jianjie1.png" alt="" />
          <p>{{ text23 }}</p>
        </div>
        <div class="left_bottom">
          <img src="https://jw-ppt.oss-cn-beijing.aliyuncs.com/zl/project/FutureGens/img/guanyu/jianjie3.png" alt="" />
          <p>{{ text25 }}</p>
        </div>
      </div>
      <!-- <div class="content_bottom_right">
        <img src="https://jw-ppt.oss-cn-beijing.aliyuncs.com/zl/project/FutureGens/img/guanyu/jianjie3.png" alt="" />
        <p>{{ text25 }}</p>
      </div> -->
    </div>
  </div>
</template>

<script>
let language = localStorage.getItem("language") || "cn";
import { mapState } from "vuex";
export default {
  data() {
    
    switch (language) {
      case "cn":
        return {
          text17: "关于明济生物",



          text18: "明济生物是一家以创新治疗性抗体类药物研发为核心，具备一体化药物开发及生产能力的临床后期生物制药企业。公司专注于肿瘤及免疫相关疾病领域，致力于发现、开发、生产和商业化具有临床价值的创新生物疗法，以解决尚未被充分满足的临床需求。",
          text19:"",
          text20:"依托自主研发的STEP（Structure-based Targeted Evolution Platform）抗体发现与优化平台，以及对疾病生物学、靶点机制和药物作用机制的深入理解，公司构建了涵盖单抗、双抗及ADC等多种药物形式的差异化创新产品管线，核心产品FG-M108已进入临床后期开发阶段，另有一款创新抗体药物与全球领先生物制药企业艾伯维（AbbVie）达成创新抗体药物全球许可合作。",
          text21: "公司现已建立覆盖抗体发现、药物开发、CMC及GMP生产的一体化研发体系，在北京大兴建有超5,000平方米的GMP生产基地，为创新药物的临床开发、注册申报及未来商业化提供有力支撑。",
          text22: "明济生物始终秉持“疾病治愈，病人可及”的使命，坚持科学与技术双驱动，以临床价值为导向，持续推动创新，致力于成为具有全球竞争力的创新生物制药企业，为全球患者带来更具价值的治疗选择。",
          text28: "",



          text23: "研发中心及中试生产基地位于大兴",
          text24: "研发副中心位于昌平",
          text25: "上海分公司位于静安",
          text27: "媒体报道",
          isShow: false,
        };
        break;
      case "en":
        return {
          text17: "About FutureGen",
          text18: "FutureGen is an innovative biopharmaceutical company committed to providing high-quality innovative biologics for patients with cancer, immune diseases and other diseases. ",
          text19:
            "FutureGen was founded in San Francisco, USA in 2014. The founder and co-founders have more than 20 years of experience in the development of innovative antibodies in multinational pharmaceutical companies. They led the development of a series of antibody drugs for malignant tumors, immune diseases and viral infections, and published several papers in Cell, Nature and other journals. FutureGen began to set up R&D center in Beijing, China in 2016 and successful completion of  Series A financing in 2018. ",
          text20:
            "FutureGen has developed a series of innovative antibody drugs with independent intellectual property rights and established a unique STEP technology platform, and the innovative antibody engineering technology with antibody intelligent design and dynamic evolutionary screening applied in antibody screening and humanization, tumor immune target and antibody verification platform, and stable cell line construction platform. The company has designed and developed innovative monoclonal antibodies, bispecific antibodies, multispecific antibodies and ADC drugs based on these technology platforms and deep understandings in tumor immunity and antibody engineering. ",
          text21:
            "In addition, FutureGen has completed the construction of a pilot production base in Daxing, Beijing, and initially established a complete industrial chain of antibody drug development, covering the upstream antibody drug screening and validation platform, as well as the downstream antibody drug production platform, such as pilot test, drug analysis and quality control. ",
          text22: "FutureGen′s first independently developed product, M108 entered clinical trial in 2021, for which the medical team was set up in Shanghai. ",
          text28: "We hope to grow into a globally leading biopharmaceutical with talents to develop innovative biologics that can truly meet clinical needs and relieve patient suffering. ",
          text23: "The R&D Center and Pilot Production Base are located in Daxing, Beijing, China.",
          text24: "The sub-R&D Center is located in Changping, Beijing, China. ",
          text25: "The branch is located in Jing 'an, Shanghai, China. ",
          text27: "Media Report",
          isShow: false,
        };
        break;
    }
  },
  computed: {
    ...mapState(["isLanguage"]),
  },
  methods: {
    changeLang(flag) {
      // console.log(flag);
      // this.isLanguage = flag;
      // this.$store.commit("setisLanguage", flag);
      language = flag;
      localStorage.setItem("language", language);
      location.reload();
    },
    toggle: function () {
      console.log(111);
      // document.getElementById("list_hide").toggle()
      this.isShow = !this.isShow;
    },
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
body {
  overflow-x: hidden;
}

.div {
  position: sticky;
  top: 0;
  width: 100vw;
  height: 130px;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.3);
  .box {
    .list {
      color: #fff;
      li {
        height: 25px;
        text-align: center;
        line-height: 30px;
        a {
          color: #fff;
          text-decoration: none;
        }
        div {
          a {
            color: black;
          }
        }
        .hide {
          p {
            color: #333;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .div {
    width: 100vw;
    height: 56px;
    .box {
      position: relative;
      padding-top: 0px;
      height: 56px;
      background-color: rgba(0, 0, 0, 0.2);
      .logo {
        display: none;
      }
      .list {
        position: absolute;
        top: 105%;
        left: 0;
        width: 100vw;
        height: 60vh;
        box-sizing: border-box;
        background-color: #203864;
        flex-direction: column;
        padding: 30px;
        text-align: left;
        li {
          a {
            color: #fff;
            line-height: 50px;
          }
          div {
            top: 8px;
            left: 33%;
            width: 120px;
          }
        }
      }
      .taggle {
        display: none;
      }
      .hide {
        width: 100vw;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .hide_left {
          position: relative;
          width: 26px;
          height: 40px;
          margin-left: 10px;
          background: url("https://jw-ppt.oss-cn-beijing.aliyuncs.com/zl/project/FutureGens/src/icon.png") no-repeat;
          background-position: -104px 0;
          .list_hide {
            position: absolute;
            width: 60vw;
            top: 112%;
            left: -20px;
            width: 100vw;
            height: 100vh;
            list-style: none;
            box-sizing: border-box;
            background-color: #203864;
            flex-direction: column;
            padding: 16px 30px;
            li {
              font-size: 20px;
              display: flex;
              flex-direction: column;
              a {
                color: #fff;
                line-height: 30px;
              }
              .nav_two {
                margin-left: 20px;
                font-size: 16px;
              }
              div {
                top: 90px;
                left: 33%;
                width: 120px;
                background-color: rgba(0, 0, 0, 0.493);
              }
              .hide {
                display: none;
                z-index: 99;
              }
            }
            :hover .hide {
              display: block;
            }
          }
        }

        .hide_logo {
          img {
            width: 100px;
            margin-left: 20px;
            margin-top: 4px;
            -webkit-tap-highlight-color: transparent;
          }
        }
        .hide_taggle {
          position: relative;
          width: 70px;
          font-size: 18px;
          text-align: center;
          cursor: pointer;
          color: #fff;
          .hide_taggle_box {
            display: none;
            position: absolute;
            top: 120%;
            left: -25%;
            width: 75px;
            color: #333;
            padding: 7px;
            border: 1px solid rgba(51, 51, 51, 0.288);
            background-color: #fff;
          }
        }
        .hide_taggle:hover {
          .hide_taggle_box {
            display: block;
          }
        }
      }
    }
    .swiper {
      width: 100%;
      height: 250px;
    }
  }
}

.head {
  background-color: rgba(0, 0, 0, 0.3);
}
.video {
  width: 100vw;
  height: 1080px;
  margin-top: -130px;
  background: url("https://jw-ppt.oss-cn-beijing.aliyuncs.com/zl/project/FutureGens/img/guanyu/banner.png");
  img {
    margin: 27% 48%;
  }
}
.content_top {
  width: 100vw;
  background-color: #203864;
  box-sizing: border-box;
  .content_top-box {
    width: 100;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    color: #fff;
    opacity: 0.8;
    padding: 130px 0px;
    justify-content: space-between;
    box-sizing: border-box;
    h3 {
      position: relative;
      width: 22vw;
      font-size: 50px;
    }
    h3::after {
      position: absolute;
      top: 22%;
      left: 0%;
      content: "";
      width: 50px;
      height: 2px;
      opacity: 0.7;
      background-color: #ccc;
    }
    div {
      width: 829px;
      p {
        line-height: 24px;
        font-size: 18px;
      }
    }
  }
}
.content_bottom {
  width: 100%;
  max-width: 1200px;
  margin: 50px auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .content_bottom_left {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .left_top {
      border-radius: 20px;
      background-color: #203864;
      overflow: hidden;
      width: 48%;
      img {
        width: 100%;
      }
      p {
        width: 100%;
      }
    }
    .left_bottom {
      border-radius: 20px;
      background-color: #203864;
      overflow: hidden;
      width: 48%;
      img {
        width: 100%;
      }
      p {
        width: 100%;
      }
    }
  }
  .content_bottom_right {
    width: 525px;
    border-radius: 20px;
    background-color: #203864;
  }
  p {
    font-size: 22px;
    color: #fff;
    text-align: center;
    padding: 16px;
    box-sizing: border-box;
  }
}

@media screen and (max-width: 750px) {
  .video {
    height: 290px;
    background-size: 100% 100%;
    margin-top: -56px;
    img {
      width: 60px;
      height: 60px;
      margin: 31% 42%;
    }
  }
  .content_top {
    width: 100vw;
    .content_top-box {
      flex-direction: column;
      padding: 20px;
      box-sizing: border-box;
      h3 {
        width: 70vw;
        font-size: 37px;
        margin-bottom: 8vh;
      }
      h3::after {
        top: 115%;
      }
      div {
        width: 90vw;
      }
    }
  }
  .content_bottom {
    margin: 50px auto;
    flex-direction: column;
    .content_bottom_left {
      width: 87vw;
      flex-direction: column;
      p {
        font-size: 20px;
        line-height: 30px;
      }
      .left_top {
        padding-bottom: 10px;
        margin-bottom: 14px;
        img {
          width: 87vw;
        }
      }
      .left_bottom {
        margin-top: 30px;
        padding-bottom: 10px;
        img {
          width: 87vw;
        }
      }
    }
    .content_bottom_right {
      width: 87vw;
      margin-top: 40px;
      img {
        width: 87vw;
      }
      p {
        font-size: 20px;
      }
    }
  }
}
</style>
